<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-time ttLabel="job_machinetime_hhmm" [(ttModel)]="edit.job_machinetime_hhmm"></tt-time>
        <tt-textarea ttLabel="job_note" [(ttModel)]="edit.job_note"></tt-textarea>
        <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
